import { useQuery } from '@apollo/client';
import type { ReactNode } from 'react';
import { graphql } from '~/apollo/generated/v4';
import { Heading } from '~/components/common/Heading';
import type { PopoverContentProps } from '~/components/common/Popover';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/components/common/Popover';
import { Prose } from '~/components/common/Prose';
import { InfoIcon } from '~/components/common/icons/InfoIcon';

const OTHER_WIKI_POPOVER_CONTENT = graphql(`
  query OtherWikiPopoverContent($id: ID!) {
    otherWikiGet(id: $id) {
      ...otherWikiParts
    }
  }
`);

export function WikiPopoverV4({
  children,
  otherWikiId,
  popoverProps,
}: {
  children?: ReactNode;
  otherWikiId: number;
  popoverProps?: Partial<PopoverContentProps>;
}) {
  const { data, loading } = useQuery(OTHER_WIKI_POPOVER_CONTENT, {
    variables: { id: otherWikiId },
  });

  const wikiPage = data?.otherWikiGet;

  if (loading) {
    return null;
  }
  if (!wikiPage?.text) {
    console.log(`Wiki popover for ID ${otherWikiId} not found or empty`);
    return null;
  }

  return (
    <Popover>
      <PopoverTrigger>{children ?? <InfoIcon />}</PopoverTrigger>
      <PopoverContent
        {...popoverProps}
        className="w-[600px] overflow-scroll max-h-screen"
      >
        <Heading level={3}>{wikiPage.title}</Heading>
        <Prose dangerouslySetInnerHTML={{ __html: wikiPage.text }} />
      </PopoverContent>
    </Popover>
  );
}
